export const courseTimetableContent = {
  notice: {
    title: {
      redirected:
        "Your personal timetable is not available on this site. You've been navigated to the timetable for your whole course.",
      default: 'This timetable is for an entire course',
    },
    body: [
      'You may not have to attend all of the events shown here. Only those you have been allocated to. You can find more information on the ',
      {
        href: 'https://www.salford.ac.uk/askus/topics/admin-essentials/timetable-guidance',
        text: 'timetable guidance page',
      },
    ],
  },
} as const;
